import { CLEAR_CENSUSES } from './consts'

export default function clearCensuses() {
  return { type: CLEAR_CENSUSES }
}
